var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LookUpDesk',{attrs:{"Header":_vm.Header},on:{"GetHeaders":_vm.GetHeaders}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }